export const projectArray = [
    {
        privateID: "0000",
        currency: "TSH",
        serverUrl: "https://us-central1-lalertprime.cloudfunctions.net/",
        config: {
            apiKey: "AIzaSyA5AhAchC5WUEoqrIvVT0XfrC00JZeV6wc",
            authDomain: "lalertprime.firebaseapp.com",
            projectId: "lalertprime",
            storageBucket: "lalertprime.appspot.com",
            messagingSenderId: "945879314417",
            appId: "1:945879314417:web:52b9ec0cc2e2259de2de50",
            measurementId: "G-6NZB79JWK9"
        }
    },
    {
        privateID: "0001",
        currency: "TSH",
        serverUrl: "https://us-central1-lalertx.cloudfunctions.net/",
        config: {
            apiKey: "AIzaSyDqn3j62v89nQnQZVyU-P6mKEabS8GcIbE",
            authDomain: "lalertx.firebaseapp.com",
            projectId: "lalertx",
            storageBucket: "lalertx.appspot.com",
            messagingSenderId: "850748210190",
            appId: "1:850748210190:web:3a789e7c8badcf58ce905f",
            measurementId: "G-JQ65Y9YHCW"
        }
    }
];

export const generalConfig = {
    privateID: "0000",
    serverUrl: "https://us-central1-lalertprime.cloudfunctions.net/",
    config: {
        apiKey: "AIzaSyA5AhAchC5WUEoqrIvVT0XfrC00JZeV6wc",
        authDomain: "lalertprime.firebaseapp.com",
        projectId: "lalertprime",
        storageBucket: "lalertprime.appspot.com",
        messagingSenderId: "945879314417",
        appId: "1:945879314417:web:52b9ec0cc2e2259de2de50",
        measurementId: "G-6NZB79JWK9"
    }
};